// removed by extract-text-webpack-plugin
module.exports = {"container":"CJTPQP8VpSzdJbj0t7Vry","thumb":"_1aGH3OTxkHEqqxrvApWJCV","title":"_IsqYexT7L4-SUlC56kFp","textContainer":"_1N_6nHybeoYmR5C-tJmVNs","name":"_3VapM0LebS1jcvEPrMIuQO","nameInputContainer":"_1uRjsx372F67YRj6xkrbEx","nameInput":"_2psmybOWWrGdS95c4cjIs"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/MyPlaylist/components/MyPlaylistInfo.scss
// module id = 630
// module chunks = 1